import consumer from "./consumer"

export function subscribeAgentStream(conversationId, callbacks = {}) {
  console.log(`🔗 [WS] Criando assinatura para conversation=${conversationId}`)
  
  const subscription = consumer.subscriptions.create(
    { channel: "AgentStreamChannel", conversation_id: conversationId },
    {
      connected() {
        console.log(`✅ [WS] Conectado ao AgentStreamChannel (conversation=${conversationId})`)
      },
      disconnected() {
        console.log(`❌ [WS] Desconectado do AgentStreamChannel (conversation=${conversationId})`)
      },
      received(payload) {
        console.log(`📨 [WS] Payload recebido:`, payload)
        
        if (!payload || !payload.type) {
          console.warn('⚠️ [WS] Payload inválido:', payload)
          return
        }
        
        const { type, data } = payload
        const callback = callbacks[`on${type.charAt(0).toUpperCase() + type.slice(1)}`]
        
        if (callback && typeof callback === 'function') {
          try {
            callback(data)
          } catch (error) {
            console.error(`❌ [WS] Erro no callback ${type}:`, error)
          }
        } else {
          console.warn(`⚠️ [WS] Callback não encontrado para tipo: ${type}`)
        }
      }
    }
  )
  
  return subscription
}


